<template>

  <div>
    <template>
      <div id="breadcrumb-alignment" class="mb-1">
        <div class="d-flex justify-content-start breadcrumb-wrapper">
          <b-breadcrumb
            :items="breadCrumb()"
          />
        </div>
      </div>
    </template>

    <!-- Table Container Card -->

    <b-card no-body>
            <b-card-body>
                <b-row class="filters-row">
                    <b-col
                      v-if="canFilterBySom"
                      cols="12"
                      md="3"
                      class="mb-md-0 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five">

                        <v-select
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="soms"
                          label="full_name"
                          class="w-100"
                          placeholder="SOM Area"
                          v-model="somData"
                          :clearable="false"
                        >
                          <template #selected-option="{ full_name }">
                            <span v-if="full_name.length < 23">{{full_name}}</span>
                            <span v-if="full_name.length >= 23">{{full_name.substring(0, 23) + '...'}}</span>
                          </template>
                        </v-select>
                    </b-col>

                    <b-col cols="12" md="3" class="mb-md-0 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five">
                        <b-form-select v-model="siteData">
                          <b-form-select-option value="" disabled>Select</b-form-select-option>
                          <b-form-select-option :value="site._id" v-for="site in siteOptions" :key="site._id">{{site.site_name | capitalize}}</b-form-select-option>
                        </b-form-select>
                    </b-col>

                    <b-col cols="12" md="3" class="mb-md-0 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five">
                      <b-form-select v-model="supplierData">
                          <b-form-select-option value="" disabled>Select Supplier</b-form-select-option>
                          <b-form-select-option :value="supplier._id" v-for="supplier in suppliers" :key="supplier._id">{{supplier.name | capitalize}}</b-form-select-option>
                        </b-form-select>
                    </b-col>

                    <!-- <b-col cols="12" md="3" class="mb-md-0 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five" v-if="email_status == 'sent'"> -->
                    <b-col cols="12" md="3" class="mb-md-0 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five">
                      <div class="d-flex align-items-center">
                        <!-- <flat-pickr
                          v-model="date_range"
                          :config="date_config"
                          class="form-control flat-picker"
                          placeholder="Select Date Range"
                          @on-change="setDate()"
                        /> -->
                        <datepicker v-model="month_year" :format="customFormatterMonthCompleteYear" minimum-view="month" maximum-view="year" placeholder="Select Month & Year" class="custom-datepicker" @input="setMonthYear"></datepicker> 
                      </div>
                    </b-col>
                    <b-col md="3" class="mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five">
                      <b-form-group>
                        <b-form-select v-model="order_type">
                          <b-form-select-option value="" disabled>Select</b-form-select-option>                    
                          <b-form-select-option value="all">All</b-form-select-option>
                          <b-form-select-option value="monthly">Monthly</b-form-select-option>
                          <b-form-select-option value="adhoc" v-if="$store.getters.currentUser.role != 'supervisor'">Adhoc</b-form-select-option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col md="3" class="d-flex align-items-center mobile-view mobile_tab_display_block">

                      <b-button

                        variant="danger"
                        class="mobile-margin-bottom mr-1"
                        style="margin-bottom: 10px;"
                        @click="resetFilter()"
                      >
                        <span class="text-nowrap">Reset</span>
                      </b-button>

                    </b-col>

                </b-row>
            </b-card-body>
        </b-card>
    
        <b-card no-body class="mb-0" v-if="siteData != null">
      
      <!-- tab component starts -->

      <b-tabs pills justified class="margin_top_zero_mobile tab_ul button-padding table_button_tab">                
            
            <b-tab title="Pending" lazy @click="email_status = 'pending'; /* start = ''; end = ''; date_range = ''; month_year = ''; month = ''; year = '' */" :active="email_status == 'pending'">
              <template #title>
                <div class="inline-button-items" style="padding-bottom: 3%;">
                  <span>Pending</span>

                  <b-badge variant="warning" style="margin-left: 5px;" v-if="pending > 0">
                      <span>{{ pending }}</span>
                  </b-badge>

                </div>
              </template>
            </b-tab>
            
            <b-tab title="Completed" lazy @click="email_status = 'sent'" :active="email_status == 'sent'">
              <template #title>
                <div class="inline-button-items" style="padding-bottom: 3%;">
                  <span>Sent</span>
                </div>
              </template>
            </b-tab>

            <b-tab title="All" lazy @click="email_status = 'failed'; /* start = ''; end = ''; date_range = ''; month_year = ''; month = ''; year = '' */"  :active="email_status == 'failed'">
              <template #title>
                <div class="inline-button-items" style="padding-bottom: 3%;">
                  <span>Failed</span>
                </div>
              </template>
            </b-tab>

            <InventoryPurchaseOrderComponent :siteData="siteData" :supplierData="supplierData" :order_type="order_type" :email_status="email_status" :start="start" :end="end" :month="month" :year="year" :som_sites="(somData && somData._id != 'all-som') ? somData.om_sites : null"/>

        </b-tabs>

      <!-- tab component ends -->

      
    </b-card>

  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BFormGroup, BTabs, BTab,
  BBadge, BDropdown, BDropdownItem, BPagination,BBreadcrumb,BCardBody, BAlert, VBTooltip, BFormCheckbox,BForm, BFormSelect, BFormSelectOption
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { POST_API } from "../../../store/actions.type"
import Ripple from 'vue-ripple-directive'
import InventoryPurchaseOrderComponent from './InventoryPurchaseOrderComponent.vue';
import flatPickr from 'vue-flatpickr-component';
import moment from "moment";
import Bus from "../../../event-bus";
import Datepicker from 'vuejs-datepicker';
export default {
  components: {
    Datepicker,
    BAlert,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BCardBody,
    vSelect,
    BBreadcrumb,
    BFormGroup,
    BFormCheckbox,
    BForm,
    BFormSelect, 
    BFormSelectOption,
    InventoryPurchaseOrderComponent,
    BTabs, BTab, flatPickr
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip
  },
  data() {
    return {
        pending:0,
        order_type:'',
        sites:[],
        siteData:'',
        soms:[],
        somData:null,
        suppliers:[],
        supplierData:'',
        email_status:'pending',
        
        error_message:null,
        popshowDismissibleAlert:false,

        // start: ''/* moment(new Date()).tz('Asia/Singapore').startOf('month').format('DD MMM YYYY') */,
        // end: ''/* moment(new Date()).tz('Asia/Singapore').format('DD MMM YYYY') */,
        start: moment(new Date()).tz('Asia/Singapore').startOf('month').format('DD MMM YYYY'),
        end: moment(new Date()).tz('Asia/Singapore').format('DD MMM YYYY'),
        date_config: {
          mode: 'range',
          dateFormat: 'd M Y',
          defaultDate: [
            moment(new Date()).tz('Asia/Singapore').format('DD MMM YYYY'),
            moment(new Date()).tz('Asia/Singapore').format('DD MMM YYYY')
          ]
        },
        date_range: ''/* moment(new Date()).tz('Asia/Singapore').startOf('month').format('DD MMM YYYY') + ' to ' + moment(new Date()).tz('Asia/Singapore').format('DD MMM YYYY') */,
        // month_year: '',
        month_year: new Date(),
        month: '',
        year: ''
    }
  },
  computed: {
    canFilterBySom() {
      return ['admin', 'administrator', 'director'].includes(this.$store.getters.currentUser.role);
    },
    siteOptions() {
      if (!this.somData || this.somData._id == 'all-som') {
        return this.sites;
      }

      var somSiteIds = (this.somData.om_sites || []).map(function (id) { return String(id); });
      var allSiteObj = this.sites.find(function (s) { return s._id == 'all-site'; });
      var filtered = this.sites.filter(function (s) {
        return s._id != 'all-site' && somSiteIds.indexOf(String(s._id)) !== -1;
      });

      return allSiteObj ? [allSiteObj].concat(filtered) : filtered;
    }
  },
  watch: {
    somData() {
      var opts = this.siteOptions;
      var allSiteObj = opts.find(function (s) { return s._id == 'all-site'; });
      this.siteData = allSiteObj ? allSiteObj._id : (opts.length > 0 ? opts[0]._id : '');
    }
  },
  methods : {
    customFormatterMonthCompleteYear(date) {
        return moment(date).format('MMMM YYYY');
    },

    setMonthYear(){
      this.month = moment(new Date(this.month_year)).startOf('month').format('MMMM');
      this.year = moment(new Date(this.month_year)).endOf('month').format('YYYY');
    },

    setDate(){
        var date = this.date_range.split(' to ');

        if (date[1]) {
            this.start = moment(new Date(date[0])).format('YYYY-MM-DD');
            this.end = moment(new Date(date[1])).format('YYYY-MM-DD');
        }else{
            this.start = moment(new Date(date[0])).format('YYYY-MM-DD');
            this.end = moment(new Date(date[0])).format('YYYY-MM-DD');
        }
		},

    resetFilter(){

      if (this.canFilterBySom) {
        this.somData = this.soms.find(function (s) { return s._id == 'all-som'; }) || null;
      }

      this.allSites();

      this.supplierData = '';
      this.order_type = '';

      this.month_year = new Date();
      this.setMonthYear();
    },

    allSites(){
      return this.$store.dispatch(POST_API, {
          data:{
          role:this.$store.getters.currentUser.role,
          om_sites:this.$store.getters.currentUser.om_sites,
          },
          api: '/api/all-sites'
      })
      .then(() => {
          if (this.$store.getters.containsErrors) {
              this.error_message = this.$store.getters.getErrors;
          } else {
              this.sites = this.$store.getters.getResults.data;
              var obj = {
                  _id:'all-site',
                  site_name:'All Project Sites',
                  pdf_date_format: 'DD MMM YYYY',
                  pdf_time_format: 'HH:mm'
              }
              this.sites.unshift(obj);
              
              this.siteData = this.defaultSite(this.sites)._id;

              return this.sites;
          }
      });
    },
    getSoms(){
      return this.$store.dispatch(POST_API, {
         data:{
           role:this.$store.getters.currentUser.role,
         },
         api: '/api/senior-operation-managers'
      })
      .then(() => {
          if (this.$store.getters.containsErrors) {
              this.error_message = this.$store.getters.getErrors;
          } else {
              this.soms = this.$store.getters.getResults.data;

              var allSom = {
                _id: 'all-som',
                full_name: 'All SOM Areas'
              };
              this.soms.unshift(allSom);
              this.somData = allSom;

              return this.soms;
          }
      });
    },
    allSuppliers(){
      return this.$store.dispatch(POST_API, {
          data:{
          },
          api: '/api/all-suppliers'
      })
      .then(() => {
          if (this.$store.getters.containsErrors) {
              this.error_message = this.$store.getters.getErrors;
          } else {
              this.suppliers = this.$store.getters.getResults.data;
              var obj = {
                  _id:'',
                  name:'All Suppliers',
              }
              this.suppliers.unshift(obj);
              return this.suppliers;
          }
      });
    },
    
    breadCrumb(){
      var item = [{
        to: { name: 'client-dashboard' },
        text: 'Dashboard',
      }, {
        to: null,
        text: 'Inventory'
      }, {
        to: null,
        text: 'Reports'
      }, {
        to: null,
        text: 'Purchase Order',
        active: true
      }];;
      return item;
    },
    
  },
  mounted(){
    this.allSites();
    this.allSuppliers();
    if (this.canFilterBySom) {
      this.getSoms();
    }

    this.setMonthYear();
    
    Bus.$on('updateCountPO', (data) => {
      // console.log('data', data);
      this.pending = data;
    })

  }
  
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.border-danger {
  border: 2px solid #ea5455 !important;
  padding: 2px !important;
}
.border-secondary {
  border: 2px solid rgb(221, 221, 221) !important;
  padding: 2px !important;
}
.card-body{
  padding-top: 1rem !important;
}
// The filter fields wrap onto a second row on desktop once the SOM Area
// filter is shown (5 x md-3 columns > 12 cols). Bootstrap's mb-md-0 zeroes
// out each column's bottom margin at that breakpoint, so wrapped rows sit
// flush against each other. row-gap only adds space between wrapped rows,
// not after the last one.
@media (min-width: 768px) {
  .filters-row {
    row-gap: 1rem;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
